import type { AnalysisResults } from '../../services/api/novel-analysis';

type ParseFn = (str: string | null) => unknown;

export function RelationshipsTab({ relationships, parseJson }: { relationships: AnalysisResults['relationships']; parseJson: ParseFn }) {
  return (
    <div className="divide-y">
      {relationships.map((rel) => {
        const addressModes = parseJson(rel.address_modes) as { normal?: string; intimate?: string; forced?: string } | null;
        return (
          <div key={rel.id} className="p-4">
            <div className="flex items-center gap-2 mb-1 flex-wrap">
              <span className="font-medium text-sm">{rel.character_a_name}</span>
              <span className="text-gray-400">&#8596;</span>
              <span className="font-medium text-sm">{rel.character_b_name}</span>
              {rel.relationship_type && (
                <span className="px-2 py-0.5 bg-purple-100 text-purple-700 rounded text-xs">{rel.relationship_type}</span>
              )}
              {rel.power_dynamic && (
                <span className="px-2 py-0.5 bg-gray-100 text-gray-600 rounded text-xs">{rel.power_dynamic}</span>
              )}
            </div>

            {rel.description && <p className="text-sm text-gray-600">{rel.description}</p>}

            {addressModes && (
              <div className="flex gap-2 flex-wrap mt-2">
                {addressModes.normal && (
                  <span className="px-2 py-0.5 bg-gray-50 text-gray-600 rounded text-xs">日常：{addressModes.normal}</span>
                )}
                {addressModes.intimate && (
                  <span className="px-2 py-0.5 bg-pink-50 text-pink-600 rounded text-xs">親密：{addressModes.intimate}</span>
                )}
                {addressModes.forced && (
                  <span className="px-2 py-0.5 bg-red-50 text-red-600 rounded text-xs">強制：{addressModes.forced}</span>
                )}
              </div>
            )}

            {rel.perception_timeline && (
              <div className="mt-2">
                {(parseJson(rel.perception_timeline) as Array<{ chapter_index: number; summary: string; change_type: string }> || []).map((entry, i) => (
                  <div key={i} className="text-xs text-gray-500 pl-3 border-l border-gray-200">
                    第 {entry.chapter_index} 章: {entry.summary} <span className="text-gray-400">({entry.change_type})</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}
      {relationships.length === 0 && <p className="p-4 text-gray-500 text-sm">尚無關係資料</p>}
    </div>
  );
}
